export const PDF_REPORT_BUTTON_STYLES = {
  width: "48px",
  height: "48px",
  display: "flex",
  borderRadius: "50%",
  padding: "12px",
  minWidth: "auto",
};
